let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8hevm")).then(() => parcelRequire('d9C5V'));